export function getConfig(...args) {

  let serverLocal = 'https://nachovelasco.dev';
  let serverLocalDB = 'https://nachovelasco.dev';
  let serverDev = 'https://nachovelasco.wearewildoom.com';
  let serverPro = 'https://nachovelasco.com' || 'https://www.nachovelasco.com';
  let origin = window.location.origin;



	return {
		server:
			(origin === serverPro || origin === serverDev) ?
			origin + '/wp-json/' :
			serverLocalDB+'/wp-json/',
    base :
      (origin === serverPro || origin === serverDev) ?
      origin :
      serverLocalDB,
    local : window.location.origin === serverLocal,
    dev : window.location.origin === serverDev,
    prod: window.location.origin === serverPro,
    lang : 'en'
	}
}
